import { usePlaygroundRouting } from "@/pages/Playground/routing/playground-routing";
import { conversationsApi } from "@/services/conversation-service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useLayoutEffect, useRef } from "react";
import { useConversationScope } from "@/hooks/useConversationScope";
import {
  conversationQueryKeys,
  conversationScopeIdentity,
} from "@/features/playground/conversation-query-keys";

export const useDeleteConversation = (id: string, currentRouteId?: string) => {
  const queryClient = useQueryClient();
  const { navigate } = usePlaygroundRouting();
  const { scope, identity, requestScope } = useConversationScope();
  const currentIdentityRef = useRef(identity);
  useLayoutEffect(() => {
    currentIdentityRef.current = identity;
  }, [identity]);
  const { mutate } = useMutation({
    mutationFn: () => {
      return conversationsApi.deleteConversation(id, false, requestScope);
    },
    onMutate: () => ({ operationScope: scope }),
    onSuccess: (_data, _variables, context) => {
      const operationScope = context?.operationScope ?? scope;
      queryClient.invalidateQueries({
        queryKey: conversationQueryKeys.lists(operationScope),
      });
      queryClient.removeQueries({
        queryKey: conversationQueryKeys.detailConversation(operationScope, id),
      });
      if (
        currentIdentityRef.current ===
          conversationScopeIdentity(operationScope) &&
        currentRouteId &&
        currentRouteId == id
      ) {
        navigate("/playground", { replace: true });
      }
    },
  });
  return { mutate };
};
